import { connect } from 'react-redux'
import {
  addNewCustomer,
  getCustomersStart,
  customerPageChange,
  removeCustomer,
  getCustomerById,
  getCustomerByIdSuccess,
  saveCustomerUpdate,
  cancelCustomerUpdate,
  addNewCustomerInvoice,
  closeCustomerSnackBar,
  getEinvoiceOperator,
  warnCustomerToDelete,
  getAdminUsersList,
  //company details
  searchCompanyDetails,
  closeCompanyLists,
  loadSelectedCompany,
  getCountryList,
  cancelDeleteCustomer,
  openCustomerFormDialog,
  closeCustomerFormDialog,
  getUserCompanyUpdateInfo
} from '../../actions/index'
import { updateFormValues } from '../../form'
import CustomerComponent from '../../components/customer/customer.component'
import { createMenuItems } from '../../utils/invoice.utils'

const mapStateToProps = (state) => {
  const { client } = state
  const userType = client.user.data[5]

  const invoiceList = [
    { fi: 'Sähköposti', en: 'E-mail', est: 'E-post' },
    { fi: 'Kirjeposti', en: 'Post', est: 'Postkast' },
    { fi: 'Verkkolasku', en: 'E-invoice', est: 'E-arved' }
  ]

  const listPerLang = (listName) => {
    let selectedLang
    if (state.language.lang == undefined) {
      selectedLang = 'fi'
    } else {
      selectedLang = state.language.lang
    }
    if (selectedLang === 'fi') {
      switch (listName) {
        case invoiceList:
          return invoiceList.map((el) => el.fi)
        default:
          return listName
      }
    } else if (selectedLang === 'en') {
      switch (listName) {
        case invoiceList:
          return invoiceList.map((el) => el.en)
        default:
          return listName
      }
    } else if (selectedLang === 'est') {
      switch (listName) {
        case invoiceList:
          return invoiceList.map((el) => el.est)
        default:
          return listName
      }
    }
  }

  const countryList = state.customer.countryList
    ? state.customer.countryList
    : []
  const invoiceItems = createMenuItems(listPerLang(invoiceList))

  let invoiceOperators = state.customer.eInvoiceOperators
  let emptyOperator = ['']
  let combineOperators = []
  combineOperators = emptyOperator.concat(invoiceOperators)
  const eInvoiceOperators = createMenuItems(combineOperators)

  const customers = state.customer.customers.map((item) => ({
    ...item,
    full_address: `${item.delivery_address} ${item.zip_code} ${item.city}`
  }))

  return {
    countryList: countryList,
    invoiceItems: invoiceItems,
    customers: customers,
    customerRows: state.customer.customerRows,
    customerPages: !!state.customer.customers
      ? Math.ceil(state.customer.customers.length / 10)
      : 0,
    isEdit: state.customer.isEdit,
    customer_id: state.customer.customerEdit.customer_id,
    showSnackbar: state.customer.showSnackbar,
    showFailSnackbar: state.customer.showFailSnackbar,
    eInvoiceOperators: eInvoiceOperators,
    //company Details
    companyLists: state.companyLists.companyLists,
    apiSuccess: state.companyLists.apiSuccess,
    companySelected: state.companyLists.companySelected,
    userType,
    language: state.language.lang,
    isToDelete: state.customer.isToDelete,
    isToDeleteCustomerId: state.customer.isToDeleteCustomerId,
    openCustomerForm: state.customer.openCustomerForm,
    state
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    addNewCustomer: (values) => dispatch(addNewCustomer(values)),
    getCustomersStart: () => dispatch(getCustomersStart()),
    customerPageChange: (selected) => dispatch(customerPageChange(selected)),
    removeCustomer: (customer_id) => dispatch(removeCustomer(customer_id)),
    cancelDeleteCustomer: () => dispatch(cancelDeleteCustomer()),
    getCustomerById: (customer_id) => dispatch(getCustomerById(customer_id)),
    getCustomerByIdSuccess: (result) =>
      dispatch(getCustomerByIdSuccess(result)),
    saveCustomerUpdate: (values) => dispatch(saveCustomerUpdate(values)),
    cancelCustomerUpdate: () => dispatch(cancelCustomerUpdate()),
    addNewCustomerInvoice: (customer_id) =>
      dispatch(addNewCustomerInvoice(customer_id)),
    closeCustomerSnackBar: () => dispatch(closeCustomerSnackBar()),
    getEinvoiceOperator: () => dispatch(getEinvoiceOperator()),
    warnCustomerToDelete: (selected) =>
      dispatch(warnCustomerToDelete(selected)),
    getAdminUsersList: () => dispatch(getAdminUsersList()),

    //search Company details
    searchCompanyDetails: (companyName) =>
      dispatch(searchCompanyDetails(companyName)),

    //companyLists details URL
    loadSelectedCompany: (selectedCompany, formName) =>
      dispatch(loadSelectedCompany(selectedCompany, formName)),
    //close company dialog box
    closeCompanyLists: () => dispatch(closeCompanyLists()),
    getCountryList: () => dispatch(getCountryList()),
    updateFormValues: (form, values) =>
      dispatch(updateFormValues(form, values)),
    openCustomerFormDialog: () => dispatch(openCustomerFormDialog()),
    closeCustomerFormDialog: () => dispatch(closeCustomerFormDialog()),
    getUserCompanyUpdateInfo: () => dispatch(getUserCompanyUpdateInfo())
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps)

const CustomerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(CustomerComponent)

export default CustomerContainer
